import { useEffect, useState } from 'react';
import { useAuthStore } from '@/store/useAuthStore';
import { tokenService } from '@/services/token/token-service';
import { getConfigFlag } from '@/services/config/config-full-store';
import { CONFIG_KEY_ACTIVE_AI, CONFIG_KEY_AI_STEP_SUGGEST } from './constants';

type Options = {
  enabled?: boolean;
  /** Bubble Hub: skill gợi ý bước */
  loadStepSuggest?: boolean;
};

/** Login + config Active AI — dùng chung bubble Hub và embed legacy. */
export function useActiveAiGate({ enabled = true, loadStepSuggest = false }: Options = {}) {
  const hydrated = useAuthStore((s) => s.hydrated);
  const accessToken = useAuthStore((s) => s.accessToken);
  const tenantID = useAuthStore((s) => s.tenantID);
  const [activeAI, setActiveAI] = useState(false);
  const [stepSuggestOn, setStepSuggestOn] = useState(false);

  const isLoggedIn =
    enabled && hydrated && Boolean(accessToken && !tokenService.isTokenExpired(accessToken));

  useEffect(() => {
    if (!isLoggedIn) {
      setActiveAI(false);
      setStepSuggestOn(false);
      return;
    }
    let cancelled = false;
    const loadFlags = (force = false) => {
      void getConfigFlag(CONFIG_KEY_ACTIVE_AI, false, { tenantId: tenantID, force }).then((on) => {
        if (!cancelled) setActiveAI(on);
      });
      if (loadStepSuggest) {
        void getConfigFlag(CONFIG_KEY_AI_STEP_SUGGEST, false, { tenantId: tenantID, force }).then((on) => {
          if (!cancelled) setStepSuggestOn(on);
        });
      }
    };
    loadFlags(true);
    const onUpdated = () => loadFlags(true);
    window.addEventListener('bsc-config-updated', onUpdated);
    return () => {
      cancelled = true;
      window.removeEventListener('bsc-config-updated', onUpdated);
    };
  }, [isLoggedIn, tenantID, loadStepSuggest]);

  return { isLoggedIn, activeAI, stepSuggestOn, ready: isLoggedIn && activeAI };
}
